export function SetupEventKey() {
	function onKeypress(event: KeyboardEvent) {
		return false;
	}

	function onKeydown(event: KeyboardEvent): boolean {
		return false;
	}

	function onKeyup(event: KeyboardEvent) {
		return false;
	}

	return {
		onKeypress,
		onKeydown,
		onKeyup,
	};
}
